const POLOPOLY_ID_REGEX = /[1-9]{1,2}\.\d+/g

export function getContextId(url) {
  return extractPolopolyIdFromString(url)
}

function extractPolopolyIdFromString(str) {
  const matches = str.match(POLOPOLY_ID_REGEX)
  if (matches && matches.length) {
    return matches[0]
  }
  return null
}
